import { allRentalDurations, rentDurationsLanguages } from './rentDurations'
import { ContentStateInterface, RentDurations } from '../../@types/types'
import { ChipGroupFeature } from '../../components/common/inputs/chipsGroup/ChipsGroup'

export const getRentDurations = (insertionData: ContentStateInterface): ChipGroupFeature[] => {
  return allRentalDurations.map((property) => ({
    property: `rentDurations.${property}`,
    value: insertionData.rentDurations?.[property] ?? false,
    defaultTranslationText: rentDurationsLanguages[property as keyof RentDurations],
  }))
}
